/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsEntityTypeForProjectChange extends models.AppSecopsEntityType {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsEntityTypeForProjectChange");
    }

    getFixupPrototypeFunction() { return AppSecopsEntityTypeForProjectChange.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsEntityTypeForProjectChange>): AppSecopsEntityTypeForProjectChange {
        let obj = Object.assign(new AppSecopsEntityTypeForProjectChange(), model);
        AppSecopsEntityTypeForProjectChange.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsEntityTypeForProjectChange>): AppSecopsEntityTypeForProjectChange {
        if (!model) return null;
        return AppSecopsEntityTypeForProjectChange.newInstance(<AppSecopsEntityTypeForProjectChange> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsEntityTypeForProjectChange) {
        if (!obj) return;

        models.AppSecopsEntityTypeForProjectChange.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsEntityTypeForProjectChange): boolean {
        if (models.AppSecopsEntityType.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsEntityTypeForProjectChange.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * List of existing application IDs to be updated. Required for Appsecops project update
     */
    existing_application_ids: Array<string>;

}
